// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
};

export const Document = ({ width, height }: Props) => (
  <svg
    width={width || '100%'}
    height={height || '100%'}
    viewBox="0 0 24 24"
    version="1.1"
  >
    <defs>
      <path
        d="M7.07774962,0 L4.1607704,0 L1.04490623,0 C0.467714141,0 0,0.486871997 0,1.08770623 L0,4.33119809 L0,12.6688019 L0,15.9129269 C0,16.513128 0.467714141,17 1.04490623,17 L4.1607704,17 L7.8392296,17 L10.9550938,17 C11.5322859,17 12,16.513128 12,15.9129269 L12,12.6688019 L12,5.1036088 L7.07774962,0 Z M6.9950506,1 L4.46730867,1 L1.8707552,1 C1.38976178,1 1,1.42959294 1,1.95974079 L1,4.82164538 L1,12.1783546 L1,15.0408178 C1,15.5704071 1.38976178,16 1.8707552,16 L4.46730867,16 L7.53269133,16 L10.1292448,16 C10.6102382,16 11,15.5704071 11,15.0408178 L11,12.1783546 L11,5.00408936 L6.9950506,1 Z M6,1 L6.99487305,1 L11,5.0065702 L11,6.00506592 L6.99980749,6.00506592 C6.44762906,6.00506592 6,5.56089971 6,5.00424544 L6,1 Z"
        id="document-svg-path-1"
      />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icons-action/Doc/Darkblue">
        <g id="Icon" transform="translate(6.000000, 3.000000)">
          <mask id="mask-2" fill="white">
            <use xlinkHref="#document-svg-path-1" />
          </mask>
          <use
            id="Combined-Shape"
            fill="#003755"
            xlinkHref="#document-svg-path-1"
          />
        </g>
      </g>
    </g>
  </svg>
);
